/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
export type CouldBe<T> = T | undefined
export type Nullable<T> = T | null

export enum ChainId {
  ETHEREUM = 1,
  BSC = 56,
  POLYGON = 137
}

export type Chain = {
  decimals: number
  logoUri: string
  name: string
  symbol: string
}

export type Token = {
  address: string
  decimals: number
  logoUri: Nullable<string>
  name: string
  symbol: string
}
